import { render, staticRenderFns } from "./CardApproval.vue?vue&type=template&id=8f242ac2&scoped=true&"
import script from "./CardApproval.vue?vue&type=script&lang=js&"
export * from "./CardApproval.vue?vue&type=script&lang=js&"
import style0 from "./CardApproval.vue?vue&type=style&index=0&id=8f242ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f242ac2",
  null
  
)

export default component.exports